import { Scale, Transform, Translate } from "@mui/icons-material";

const components = {
  MuiOutlinedInput: {
    defaultProps: {
      inputProps: {
        sx: {
          p: 3.75,
          fontWeight: 400,
        },
      },
    },
  },
  MuiInput: {
    styleOverrides: {
      underline: {
        "&::before": {
          borderColor: "rgba(9, 31, 44, 0.25)",
        },
      },
    },
  },
  MuiInputLabel: {
    styleOverrides: {
      root: {
        fontWeight: 400,
      },
      standard: {
        color: "rgba(9, 31, 44, 0.5)",
      },
    },
  },
  MuiFormControlLabel: {
    styleOverrides: {
      root: {
        fontWeight: 400,
      },
      label: {
        fontSize: "11px",
        color: "rgba(9, 31, 44, 0.5)",
        fontFamily: "Poppins",
        fontWeight: 400,
      },
    },
  },
  MuiButtonBase: {
    defaultProps: {
      disableRipple: true,
    },
  },
  MuiButton: {
    defaultProps: {
      sx: {
        fontWeight: 500,
        // py: 2.75,
      },
    },
  },
  MuiLink: {
    defaultProps: {
      underline: "hover",
      color: "primary",
    },
  },
  // MuiDivider: {
  //   defaultProps: {
  //     sx: {
  //       borderColor: "#F1EEE7",
  //     },
  //   },
  // },
  MuiCardHeader: {
    defaultProps: {
      titleTypographyProps: {
        variant: "h6",
      },
    },
    styleOverrides: {
      action: {
        marginTop: "-4px",
        marginRight: "-4px",
      },
    },
  },
  MuiCard: {
    styleOverrides: {
      root: {
        borderRadius: "6px",
        boxShadow:
          "rgba(50, 50, 93, 0.025) 0px 2px 5px -1px, rgba(0, 0, 0, 0.05) 0px 1px 3px -1px",
        backgroundImage: "none",
      },
    },
  },
  MuiPaper: {
    styleOverrides: {
      root: {
        backgroundImage: "none",
        color: "#091F2C", // FIXME: get from theme pallete
      },
    },
  },
  MuiPickersDay: {
    styleOverrides: {
      day: {
        fontWeight: "300",
      },
    },
  },
  MuiPickersYear: {
    styleOverrides: {
      root: {
        height: "64px",
      },
    },
  },
  MuiPickersCalendar: {
    styleOverrides: {
      transitionContainer: {
        marginTop: "6px",
      },
    },
  },
  MuiPickersCalendarHeader: {
    styleOverrides: {
      iconButton: {
        backgroundColor: "transparent",
        "& > *": {
          backgroundColor: "transparent",
        },
      },
      switchHeader: {
        marginTop: "2px",
        marginBottom: "4px",
      },
    },
  },
  MuiPickersClock: {
    styleOverrides: {
      container: {
        margin: `32px 0 4px`,
      },
    },
  },
  MuiPickersClockNumber: {
    styleOverrides: {
      clockNumber: {
        left: `calc(50% - 16px)`,
        width: "32px",
        height: "32px",
      },
    },
  },
  MuiPickerDTHeader: {
    styleOverrides: {
      dateHeader: {
        "& h4": {
          fontSize: "2.125rem",
          fontWeight: 400,
        },
      },
      timeHeader: {
        "& h3": {
          fontSize: "3rem",
          fontWeight: 400,
        },
      },
    },
  },
  MuiPickersTimePicker: {
    styleOverrides: {
      hourMinuteLabel: {
        "& h2": {
          fontSize: "3.75rem",
          fontWeight: 300,
        },
      },
    },
  },
  MuiPickersToolbar: {
    styleOverrides: {
      toolbar: {
        "& h4": {
          fontSize: "2.125rem",
          fontWeight: 400,
        },
      },
    },
  },
  // MuiChip: {
  //   styleOverrides: {
  //     root: {
  //       borderRadius: "6px",
  //     },
  //   },
  // },
};

export default components;
